// Settings → Appearance → Code: how code and diffs are drawn on this device, with a sample
// that follows the switches so the effect is seen where it is set.
import { CodeBlock } from '@/components/Code'
import { SwitchRow } from '@/components/Switch'
import { useCodeLook } from '@/state/codeLook'

const SAMPLE = `type Result<T> = { ok: true; value: T } | { ok: false }

// ligatures: => !== <= >=
export function pick<T>(items: T[], index = 0): Result<T> {
  const found = items[index]
  if (found !== undefined) {
    return { ok: true, value: found }
  }
  return { ok: false }
}`

export const CodeLookSettings = () => {
  const look = useCodeLook()
  return (
    <section data-testid="code-look-settings">
      <h2 className="px-1 pb-1.5 text-[13px] font-semibold text-muted">Code and diffs</h2>
      <p className="text-xs text-faint px-1 mb-2">
        How code looks on this device: on the review screen, in replies, in any code block.
      </p>
      <div className="card px-3.5 py-1">
        <SwitchRow
          label="Colour the code"
          hint="Syntax colours like an editor's. Off shows plain text."
          on={look.highlight}
          onChange={(on) => look.set({ highlight: on })}
          testId="code-highlight"
        />
        <SwitchRow
          label="Rainbow brackets"
          hint="Each pair of brackets takes a colour by how deep it sits."
          on={look.brackets}
          onChange={(on) => look.set({ brackets: on })}
          disabled={!look.highlight}
          testId="code-brackets"
        />
        <SwitchRow
          label="Indent guides"
          hint="A tinted band for each level of indent."
          on={look.guides}
          onChange={(on) => look.set({ guides: on })}
          testId="code-guides"
        />
        <SwitchRow
          label="Ligatures"
          hint="=> and !== drawn as single signs, in the code font."
          on={look.ligatures}
          onChange={(on) => look.set({ ligatures: on })}
          testId="code-ligatures"
        />
      </div>
      <CodeBlock code={SAMPLE} lang="ts" testId="code-sample" />
    </section>
  )
}
